import { render, staticRenderFns } from "./PhysicalBooks.vue?vue&type=template&id=c19bd48e&scoped=true&"
import script from "./PhysicalBooks.vue?vue&type=script&lang=js&"
export * from "./PhysicalBooks.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalBooks.vue?vue&type=style&index=0&id=c19bd48e&RegisterBooksHomeang=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19bd48e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VIcon,VTab,VTabItem,VTabs})
